import { hrefToNext } from '../hrefTo';
export const petrolConvenience = {
    RunSummaryPetrolConvenienceLink: {
        appDomain: 'next',
        uri: hrefToNext('/run/run-summary-petrol-and-convenience'),
        label: {
            new: 'Run Summary (Petrol & Convenience)',
            old: 'Run Summary (Petrol & Convenience)',
        },
        icon: {
            new: 'fas fa-clipboard-list',
            old: 'fas fa-clipboard-list',
        },
    },
    SevenElevenOrdersExport: {
        appDomain: 'next',
        uri: hrefToNext('/petrol-convenience/orders-export'),
        label: {
            new: '7Eleven Orders Export',
            old: '7Eleven Orders Export',
        },
        icon: {
            new: 'fas fa-gas-pump',
            old: 'fas fa-gas-pump',
        },
    },
    SevenElevenThawdownArticles: {
        appDomain: 'next',
        uri: hrefToNext('/petrol-convenience/thawdown-articles'),
        label: {
            new: '7Eleven Thawdown Articles',
            old: '7Eleven Thawdown Articles',
        },
        icon: {
            new: 'fas fa-gas-pump',
            old: 'fas fa-gas-pump',
        },
    },
    SevenElevenItemsDashboard: {
        appDomain: 'next',
        uri: hrefToNext('/petrol-convenience/seven-eleven-items'),
        label: {
            new: '7Eleven Items Dashboard',
            old: '7Eleven Items Dashboard',
        },
        icon: {
            new: 'fas fa-gas-pump',
            old: 'fas fa-gas-pump',
        },
    },
};
